import { initializeApp, getApps, getApp } from 'firebase/app'
import {
  getAuth,
  GoogleAuthProvider,
  OAuthProvider,
  setPersistence,
  browserLocalPersistence,
} from 'firebase/auth'
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'

// Public web config for the shared `kidneyrecipes` Firebase project.
// Same values funnel/website use — public by design.
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyC9lSvdpQKR1XEsDKQ9mc6EfjaVjkZYreU',
  authDomain: 'kidneyrecipes.firebaseapp.com',
  projectId: 'kidneyrecipes',
  storageBucket: 'kidneyrecipes.firebasestorage.app',
  messagingSenderId: '810820724974',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:810820724974:web:4f3cd0fdb33b892f83abff',
  measurementId: 'G-TVR0HLECHD',
}

export const app = getApps().length ? getApp() : initializeApp(firebaseConfig)

export const auth = getAuth(app)

// Offline persistence (IndexedDB) — older users on flaky connections keep working.
// ignoreUndefinedProperties matches the mobile writers' strip-undefined behavior:
// analysis payloads have optional nutrients, and Firestore rejects undefined otherwise.
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
  ignoreUndefinedProperties: true,
})

export const functions = getFunctions(app)
export const storage = getStorage(app)

// Keep the session across reloads/tabs.
void setPersistence(auth, browserLocalPersistence).catch(() => {
  /* falls back to in-memory if storage is unavailable */
})

export const googleProvider = new GoogleAuthProvider()
// Always show the account chooser, so a user who signed into the wrong Google
// account can pick the right one after signing out (4.36 A1).
googleProvider.setCustomParameters({ prompt: 'select_account' })

export const appleProvider = new OAuthProvider('apple.com')
appleProvider.addScope('email')
appleProvider.addScope('name')
